import { render, staticRenderFns } from "./bellIcon.vue?vue&type=template&id=18146a06&"
import script from "./bellIcon.vue?vue&type=script&lang=js&"
export * from "./bellIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports